import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  metric?: string;
  actions?: ReactNode;
  className?: string;
}

export function SectionHeader({
  title,
  subtitle,
  metric,
  actions,
  className,
}: SectionHeaderProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-xl border bg-surface-elevated/85 p-4 shadow-panel backdrop-blur md:flex-row md:items-center md:justify-between',
        className,
      )}
    >
      <div className="min-w-0 space-y-1">
        <div className="flex items-center gap-2">
          <h2 className="font-display text-lg font-semibold tracking-tight">{title}</h2>
          {metric ? (
            <span className="rounded-full bg-surface-focus px-2.5 py-1 text-xs font-semibold text-foreground/80">
              {metric}
            </span>
          ) : null}
        </div>
        {subtitle ? <p className="text-sm text-muted-foreground">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}

